import { createEffect, createSignal } from "solid-js"
import createEntityGridXYV2 from "../../lib/core/tile_position_xy/createEntityGridXYV2"
import type { EntityGridXYV2 } from "../../lib/core/tile_position_xy/EntityGridXYV2.type"
import { immutableEmptyArray } from "../../lib/lib"
import createSharedCachedFactory from "./createSharedCachedFactory"
import useGridWidthHeight from "./useGridWidthHeight"

export const useEntityGridXYV2Memo = createSharedCachedFactory((engine) => {
  const getGridSize = useGridWidthHeight(engine)

  const [getEntityGridXYV2, setEntityGridXYV2] = createSignal<EntityGridXYV2>(immutableEmptyArray as unknown as EntityGridXYV2)

  createEffect(() => {
    const { width, height } = getGridSize()
    createEffect(() => {
      try {
        setEntityGridXYV2(createEntityGridXYV2(engine.state.ents, width, height))
      } catch (error) {
        // sometimes throws this error when /maps/create changes grid size
        // but it seems to be recoverable
        // Error creating entity grid XYV2: Error: Entity 31019 has invalid coordinates (10, 2) outside grid bounds (10x10)
        console.error('Error creating entity grid XYV2:', error)
      }
    })
  })

  return getEntityGridXYV2
})